'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import DeliveryIdContext from '../../context/delivery-id-context';
import GeneralCarouselClientBoundary from '@components/carousels/GeneralCarousel/_GeneralCarouselClientBoundary';
import { LinkProps } from '@repo/ui/src/types/link';
import { AuthorProps } from '@repo/ui/src/types/author';

interface RecipeCarouselProps {
  title?: string;
  description?: string;
  viewAllLink?: LinkProps;
  author: AuthorProps;
  sort?: string;
}
const RecipeCarousel = ({ title, description, viewAllLink, author, sort }: RecipeCarouselProps) => {
  const { locale } = useCurrentUrl();

  let sortField = 'Popularity';
  let sortDirection = 'desc';
  if (sort) {
    [sortField, sortDirection] = sort.split(',');
  }
  const deliveryId = useContext(DeliveryIdContext);

  const [recipes, setRecipes] = useState([]);

  const loadRecipes = () => {
    const { CancelToken } = axios;
    const source = CancelToken.source();
    const fetchData = async () => {
      try {
        const res = await axios.post(
          '/api/recipe-category/getRecipeCategory',
          {
            categories:
              author?.id || deliveryId
                ? [
                    {
                      authorId: author?.id || deliveryId,
                    },
                  ]
                : [],
            page: 0,
            sort: { field: sortField, direction: sortDirection },
            lang: locale,
          },
          {
            cancelToken: source.token,
          },
        );

        if (res?.data) {
          // Ensure each recipe has the correct schema for CarouselItem rendering
          const recipesWithSchema = res.data.hits.map((recipe: any) => ({
            ...recipe,
            _meta: {
              ...recipe._meta,
              schema:
                recipe._meta?.schema ||
                'https://traegergrills.com/data/contentTypes/recipeSimple.json',
            },
          }));
          setRecipes(recipesWithSchema);
        }
      } catch {
        // Just don't show recipes
      }
    };
    fetchData();
    return source;
  };

  useEffect(() => {
    const source = loadRecipes();
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, []);

  if (!recipes?.length) {
    return null;
  }

  return (
    <div className="jumbotron rotating-background">
      <GeneralCarouselClientBoundary
        _data={recipes}
        title={title}
        viewAllLink={viewAllLink}
        description={description}
      />
    </div>
  );
};

export default RecipeCarousel;
